const INDICADORES = {
  IPCA: {
    indicador_id: "IPCA",
    indicador: "Índice Nacional de Preços ao Consumidor Amplo",
    indicador_tipo_id: "C",
  },
  IGPM: {
    indicador_id: "IGPM",
    indicador: "Índice Geral de Preços do Mercado",
    indicador_tipo_id: "C",
  },
  DI: { indicador_id: "DI", indicador: "Taxa DI", indicador_tipo_id: "J" },
  POUP: { indicador_id: "POUP", indicador: "Poupança", indicador_tipo_id: "J" },
  SELIC: {
    indicador_id: "SELIC",
    indicador: "Taxa Selic",
    indicador_tipo_id: "J",
  },
  IBOV: {
    indicador_id: "IBOV",
    indicador: "Índice Bovespa",
    indicador_tipo_id: "I",
  },
  IDIV: {
    indicador_id: "IDIV",
    indicador: "Índice Dividendos",
    indicador_tipo_id: "I",
  },
  IFIX: {
    indicador_id: "IFIX",
    indicador: "Índice Fundos Investimento Imobiliários B3",
    indicador_tipo_id: "I",
  },
  IMAB: {
    indicador_id: "IMAB",
    indicador: "Índice de Mercado ANBIMA indexado ao IPCA",
    indicador_tipo_id: "I",
  },
  USD: {
    indicador_id: "USD",
    indicador: "Dólar",
    indicador_tipo_id: "M",
  },
};

export default INDICADORES;
